import Head from "components/Head"
import JobHeader from "components/jobs/JobHeader"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"

/*
  This example requires Tailwind CSS v2.0+ 
  
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
export default function Example() {
  const router = useRouter()
  const [role, setRole] = useState(router.query.role)
  const [fileName, setFileName] = useState("")

  useEffect(() => {
    if (router.query?.role) {
      setRole(router.query.role)
    }
  }, [router.query?.role])

  const handleFileChange = (event: any) => {
    const file = event.target.files[0]
    if (file) {
      setFileName(file.name)
    } else {
      setFileName("")
    }
  }

  return (
    <>
      <div className="h-full">
        <Head share_img="https://paragraph.xyz/featureline/success.png" />

        <main className="h-full">
          <JobHeader />

          <div className="bg-gray-50 h-full py-12">
            <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
              <div className="hidden sm:block" aria-hidden="true">
                <div className="py-5">
                  <div className="border-t border-gray-200" />
                </div>
              </div>

              <form
                action="/api/careers/apply"
                method="post"
                encType="multipart/form-data"
              >
                <div className="mt-10 sm:mt-0">
                  <div className="md:grid md:grid-cols-3 md:gap-6">
                    <div className="md:col-span-1">
                      <div className="px-4 sm:px-0">
                        <h3 className="text-lg font-medium leading-6 text-gray-900">
                          Apply to Paragraph
                        </h3>
                        <p className="mt-1 text-sm text-gray-600">
                          Thanks for your interest! We'd love to hear from you.
                          For any questions, please reach out to
                          careers@paragraph.xyz.
                        </p>
                      </div>
                    </div>
                    <div className="mt-5 md:mt-0 md:col-span-2">
                      <div className="shadow overflow-hidden sm:rounded-md">
                        <div className="px-4 py-5 bg-white sm:p-6">
                          <div className="grid grid-cols-6 gap-6">
                            <div className="col-span-6 sm:col-span-3">
                              <label
                                htmlFor="role"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Role
                              </label>
                              <input
                                type="text"
                                name="role"
                                id="role"
                                defaultValue={role}
                                className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                            </div>

                            <div className="col-span-6 sm:col-span-3">
                              <label
                                htmlFor="email-address"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Email address
                              </label>
                              <input
                                type="text"
                                name="email-address"
                                id="email-address"
                                autoComplete="email"
                                className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                            </div>

                            <div className="col-span-6 sm:col-span-3">
                              <label
                                htmlFor="first-name"
                                className="block text-sm font-medium text-gray-700"
                              >
                                First name
                              </label>
                              <input
                                type="text"
                                name="first-name"
                                id="first-name"
                                autoComplete="given-name"
                                className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                            </div>

                            <div className="col-span-6 sm:col-span-3">
                              <label
                                htmlFor="last-name"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Last name
                              </label>
                              <input
                                type="text"
                                name="last-name"
                                id="last-name"
                                autoComplete="family-name"
                                className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                            </div>

                            <div className="col-span-6 sm:col-span-6">
                              <label
                                htmlFor="country"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Relevant links & artifacts
                              </label>
                              <p className="text-gray-500 text-sm">
                                Please provide links to anything you'd like to
                                share with us (personal website, LinkedIn,
                                GitHub, ENS/wallet address, etc).
                              </p>

                              <div className="mt-1">
                                <textarea
                                  id="about"
                                  name="about"
                                  rows={3}
                                  className="shadow-sm focus:ring-blue-500 focus:border-blue-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md"
                                  placeholder="Twitter: @yourname, Github: @johndoe, personal website: www.example.com, LinkedIn: linkedin.com/in/johndoe"
                                  defaultValue={""}
                                />
                              </div>
                            </div>

                            <div className="col-span-6 sm:col-span-6">
                              <label
                                htmlFor="country"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Free-form text box
                              </label>
                              <p className="text-gray-500 text-sm">
                                Feel free to share anything else you'd like
                                here. Why would you make a great fit? What
                                excites you in crypto? What do you think we're
                                doing right (or wrong)?
                              </p>

                              <div className="mt-1">
                                <textarea
                                  id="free-form-text"
                                  name="free-form-text"
                                  rows={3}
                                  className="shadow-sm focus:ring-blue-500 focus:border-blue-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md"
                                  defaultValue={""}
                                />
                              </div>
                            </div>

                            <div className="col-span-6">
                              <label
                                htmlFor="street-address"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Location (City, Country)
                              </label>
                              <input
                                type="text"
                                name="street-address"
                                id="street-address"
                                autoComplete="street-address"
                                className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                            </div>

                            <div className="grid grid-cols-3 gap-6">
                              <div>
                                <label className="block text-sm font-medium text-gray-700">
                                  Resume/CV
                                </label>
                                <div className="mt-1 flex items-center">
                                  <label
                                    htmlFor="resume"
                                    className="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-blue-500"
                                  >
                                    <span>Attach</span>
                                    <input
                                      id="resume"
                                      name="resume"
                                      type="file"
                                      className="sr-only"
                                      onChange={handleFileChange}
                                    />
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <span className="text-gray-500 text-sm">
                            {fileName}
                          </span>
                        </div>
                        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                          <button
                            type="submit"
                            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <div className="hidden sm:block" aria-hidden="true">
                <div className="py-5">
                  <div className="border-t border-gray-200" />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  )
}
